<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Budget",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "View Budget",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Budget",
          active: true,
        },
      ],
      totalRows: 1,
      totalRows1: 1,
      currentPage: 1,
      currentPage1: 1,
      perPage1: 10,
      perPage: 10,
      pageOptions1: [10, 25, 50, 100],
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filter1: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      filterOn1: [],
      sortBy11: "age",
      sortDesc1: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "category",
          label: "Expense Category",
          sortable: true,
        },
        {
          sortable: false,
          key: "items_field",
          label: "Expense Items",
        },
        {
          sortable: false,
          key: "budget_field",
          label: "Budget Amount",
        },
        {
          sortable: false,
          key: "spent_field",
          label: "Amount Spent",
        },
        {
          sortable: false,
          key: "balance_field",
          label: "Balance",
        },
      ],
      fields1: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Revenue Category",
          sortable: true,
        },
        {
          sortable: false,
          key: "amount",
          label: "Budget Amount",
        },
        {
          sortable: false,
          key: "received",
          label: "Amount Received",
        },
        {
          sortable: false,
          key: "balance",
          label: "Balance",
        },
      ],
      data: {
        fyear: "",
      },
      assigned: [],
      fyearError: "",
    };
  },
  computed: {
    ...mapGetters("budget", [
      "FinancialYears",
      "ExpenseProjection",
      "RevenueProjection",
      "SaveStatus",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.assigned ? this.assigned.length : 1;
    },
    rows1() {
      return this.RevenueProjection ? this.RevenueProjection.length : 1;
    },
  },
  watch: {
    ExpenseProjection(newValue) {
      if (newValue) {
        this.assign();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.assigned ? this.assigned.length : 1;
    this.totalRows1 = this.RevenueProjection
      ? this.RevenueProjection.length
      : 1;
  },
  methods: {
    ...mapActions({
      FetchFinancialYear: "budget/fetchFyears",
      FetchExpProjection: "budget/fetchExpProjection",
      FetchRevProjection: "budget/fetchRevProjection",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.assigned ? this.assigned.length : 1;
      this.currentPage = 1;
    },
    onFiltered1() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = this.RevenueProjection
        ? this.RevenueProjection.length
        : 1;
      this.currentPage1 = 1;
    },
    assign() {
      this.assigned = this.ExpenseProjection;
    },
  },
  created() {
    this.FetchFinancialYear();
    this.FetchExpProjection(this.data);
    this.FetchRevProjection(this.data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_budget')
        )
      "
    >
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Financial Year</label>
                      <div class="input-group">
                        <model-list-select
                          :list="FinancialYears ? FinancialYears : []"
                          v-model="data.fyear"
                          option-value="id"
                          option-text="name"
                          class="mb-2"
                          @input="resetError()"
                          placeholder="Select Financial Year"
                        >
                        </model-list-select>
                      </div>
                      <div class="text-danger" v-if="fyearError">
                        <em>{{ fyearError }}</em>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-4">
                    <button class="btn btn-success">
                      <i class="fa fa-search"></i> Search
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <!-- <button v-b-modal.add-stream-modal class="btn btn-primary float-end"><i class="fa fa-plus"></i> Add New</button> -->
              </div>
            </div>
            <div class="row mt-2">
              <b-tabs
                justified
                nav-class="nav-tabs-custom"
                content-class="p-3 text-muted"
              >
                <b-tab active>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Expense Budget</span>
                  </template>
                  <!-- Content goes here -->
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                          Show&nbsp;
                          <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                          ></b-form-select
                          >&nbsp;entries
                        </label>
                      </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end"
                      >
                        <label class="d-inline-flex align-items-center">
                          Search:
                          <b-form-input
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                          ></b-form-input>
                        </label>
                      </div>
                    </div>
                    <!-- End search -->
                    <!-- Table -->
                    <div class="table-responsive mb-0">
                      <b-table
                        class="datatables"
                        :items="assigned ? assigned : []"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        @filtered="onFiltered"
                      >
                        <template #cell(index)="data">
                          {{ data.index + 1 }}
                        </template>
                        <template #cell(items_field)="data">
                          <table width="100%">
                            <tr
                              v-for="(item, index) in data.item.items"
                              :key="index"
                            >
                              <td width="50%">{{ item.itemName }}</td>
                            </tr>
                          </table>
                          <strong>Sub Totals</strong>
                        </template>
                        <template #cell(budget_field)="data">
                          <table width="100%">
                            <tr
                              v-for="(item, index) in data.item.items"
                              :key="index"
                            >
                              <td width="50%">
                                {{ item.amount }}
                              </td>
                            </tr>
                          </table>
                          <strong>{{ data.item.total }}</strong>
                        </template>
                        <template #cell(spent_field)="data">
                          <table width="100%">
                            <tr
                              v-for="(item, index) in data.item.items"
                              :key="index"
                            >
                              <td width="50%">
                                {{ item.spent }}
                              </td>
                            </tr>
                          </table>
                          <strong>{{ data.item.spent }}</strong>
                        </template>
                        <template #cell(balance_field)="data">
                          <table width="100%">
                            <tr
                              v-for="(item, index) in data.item.items"
                              :key="index"
                            >
                              <td width="50%">
                                {{ item.balance }}
                              </td>
                            </tr>
                          </table>
                          <strong>{{ data.item.balance }}</strong>
                        </template>
                      </b-table>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div
                          class="
                            dataTables_paginate
                            paging_simple_numbers
                            float-end
                          "
                        >
                          <ul class="pagination pagination-rounded mb-0">
                            <!-- pagination -->
                            <b-pagination
                              v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                            ></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="far fa-user"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Income Budget</span>
                  </template>
                  <!-- Content goes here -->
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                          Show&nbsp;
                          <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage1"
                            size="sm"
                            :options="pageOptions1"
                          ></b-form-select
                          >&nbsp;entries
                        </label>
                      </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end"
                      >
                        <label class="d-inline-flex align-items-center">
                          Search:
                          <b-form-input
                            v-model="filter1"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                          ></b-form-input>
                        </label>
                      </div>
                    </div>
                    <!-- End search -->
                    <!-- Table -->
                    <div class="table-responsive mb-0">
                      <b-table
                        class="datatables"
                        :items="RevenueProjection ? RevenueProjection : []"
                        :fields="fields1"
                        responsive="sm"
                        :per-page="perPage1"
                        :current-page="currentPage1"
                        :sort-by.sync="sortBy1"
                        :sort-desc.sync="sortDesc1"
                        :filter="filter1"
                        :filter-included-fields="filterOn1"
                        @filtered="onFiltered1"
                      >
                        <template #cell(index)="data">
                          {{ data.index + 1 }}
                        </template>
                        <template #cell(items_field)="data">
                          <table width="100%">
                            <tr
                              v-for="(item, index) in data.item.items"
                              :key="index"
                            >
                              <td width="50%">{{ item.itemName }}</td>
                            </tr>
                          </table>
                          <strong>Sub Totals</strong>
                        </template>
                        <template #cell(budget_field)="data">
                          <table width="100%">
                            <tr
                              v-for="(item, index) in data.item.items"
                              :key="index"
                            >
                              <td width="50%">
                                {{ item.amount }}
                              </td>
                            </tr>
                          </table>
                          <strong>{{ data.item.total }}</strong>
                        </template>
                        <template #cell(spent_field)="data">
                          <table width="100%">
                            <tr
                              v-for="(item, index) in data.item.items"
                              :key="index"
                            >
                              <td width="50%">
                                {{ item.spent }}
                              </td>
                            </tr>
                          </table>
                          <strong>{{ data.item.spent }}</strong>
                        </template>
                        <template #cell(balance_field)="data">
                          <table width="100%">
                            <tr
                              v-for="(item, index) in data.item.items"
                              :key="index"
                            >
                              <td width="50%">
                                {{ item.balance }}
                              </td>
                            </tr>
                          </table>
                          <strong>{{ data.item.balance }}</strong>
                        </template>
                      </b-table>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div
                          class="
                            dataTables_paginate
                            paging_simple_numbers
                            float-end
                          "
                        >
                          <ul class="pagination pagination-rounded mb-0">
                            <!-- pagination -->
                            <b-pagination
                              v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                            ></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.required {
  color: red !important;
}
/* .custom{
    width: 350px;
} */
</style>
